"use client";

import { useEffect } from "react";
import Script from "next/script";
import { useTranslations } from "next-intl";
import HeroCarousel from "@/components/ui/hero-carousel";
import { Check } from "lucide-react";
import Banner from "@/components/ui/banner";

export default function SolicitudesPage() {
  const t = useTranslations("solicitudesPage");
  const benefits = t.raw("benefits.items") as Array<{ title: string; description: string }>;

  useEffect(() => {
    // no-op: script will initialize the form on load
  }, []);

  return (
    <div className="min-h-screen bg-surface-light text-ink dark:bg-surface-dark dark:text-gray-100">
      <Banner
        title={t("hero.title")}
        subtitle={t("hero.subtitle")}
        backgroundImage="/static/backgrounds/footer-background.webp"
      />
      <div className="px-4 py-10">
      <div className="mx-auto max-w-6xl grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Left column: carousel + benefits */}
        <div className="space-y-6">
          <HeroCarousel
            alt={t("hero.title")}
            compact
            initialImages={[
              "/static/home/hero-illustration-carousel-01.webp",
              "/static/home/hero-illustration-carousel-02.webp",
              "/static/home/hero-illustration-carousel-03.webp",
              "/static/home/hero-illustration-carousel-04.webp",
            ]}
          />
          <div className="rounded-2xl bg-white p-6 shadow-md dark:bg-surface-dark-raised">
            <h3 className="text-xl font-bold text-brand-navy dark:text-white mb-4">{t("benefits.title")}</h3>
            <div className="grid gap-3">
              {benefits.map((b) => (
                <div key={b.title} className="flex items-start gap-3">
                  <Check className="w-6 h-6 text-green-500 mt-1.5" />
                  <div>
                    <p className="font-semibold text-brand-navy dark:text-white text-lg">{b.title}</p>
                    <p className="text-gray-600 dark:text-gray-300 text-lg mt-1">{b.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Right column: HubSpot form */}
        <div>
          <div className="rounded-2xl bg-white p-6 shadow-md dark:bg-surface-dark-raised">
            <h3 className="text-xl font-bold text-brand-navy dark:text-white mb-4">{t("hero.formTitle")}</h3>
            <div id="hubspot-form-container" />
            <Script
              src="//js.hsforms.net/forms/embed/v2.js"
              strategy="afterInteractive"
              onLoad={() => {
                try {
                  if (window.hbspt?.forms?.create) {
                    window.hbspt.forms.create({
                      portalId: "6072528",
                      formId: "dd2ac092-7ed3-4a9a-a07f-541fc2c0737a",
                      region: "na1",
                      target: "#hubspot-form-container",
                    });
                  }
                } catch {
                  // silent
                }
              }}
            />
          </div>
        </div>
      </div>
      </div>
    </div>
  );
}
